import { Link } from 'react-router';
import { useT } from '@/app/prefs';
import { Card, EmptyState } from '@/components/ui';

export function ForbiddenPage() {
  const t = useT();

  return (
    <>
      <div className="sn-pagehead">
        <h1>403</h1>
      </div>
      <Card flush>
        <EmptyState
          icon="alert"
          title={t.errors.FORBIDDEN}
          action={
            <Link to="/" className="btn btn-secondary">
              {t.common.backHome}
            </Link>
          }
        />
      </Card>
    </>
  );
}
